<template>
  <UsersListView />
</template>

<script>
// @ is an alias to /src
import UsersListView from "@/components/UsersListView.vue";

export default {
  name: "Users",
  components: {
    UsersListView
  }
};
</script>
